import Datas from './Datas'

class Auto extends Datas {
  constructor(autos = false) {
    super()
    this.files = {}
    this.data = {
      sts: {
        value: '',
        require: false,
        fieldName: 'ctc_auto',
        is_file: false,
      },

      user_org_inn: {
        value: '',
        require: true,
        fieldName: 'user_org_inn',
        is_file: false,
      },
      id: {
        value: '',
        require: false,
        fieldName: 'id',
        is_file: false,
      },

      nameOwnerTrailer: {
        value: '',
        require: false,
        fieldName: 'name_owner_trailer',
        is_file: false,
      },

      stsTrailer: {
        value: '',
        require: false,
        fieldName: 'ctc_trailer',
        is_file: false,
      },
      vin: {
        value: '',
        require: false,
        fieldName: 'vin_auto',
        is_file: false,
      },
      isOwner: {
        value: '',
        require: false,
        fieldName: 'is_owner',
        is_file: false,
      },
      mark: {
        value: '',
        require: true,
        fieldName: 'brand',
        is_file: false,
      },

      nameCarrier: {
        value: '',
        require: false,
        fieldName: 'carrier_name',
        is_file: false,
      },
      innCarrier: {
        value: '',
        require: true,
        fieldName: 'carrier_inn',
        is_file: false,
      },
      innOwner: {
        value: '',
        require: true,
        fieldName: 'inn_owner',
        is_file: false,
      },
      nameOwner: {
        value: '',
        require: true,
        fieldName: 'name_owner',
        is_file: false,
      },

      plate: {
        value: '',
        require: true,
        fieldName: 'state_numbers',
        is_file: false,
      },
      plateTrailer: {
        value: '',
        require: true,
        fieldName: 'state_numbers_trailer',
        is_file: false,
      },
      sts_date: {
        type_file: 6,
        fieldName: 'ctc_auto_date',
        is_file: false,
      },
      rent_add_date: {
        type_file: 8,
        fieldName: 'date_expire',
        is_file: true,
      },
      leasingDoc: {
        type_file: 11,
        fieldName: 'date_expire',
        is_file: true,
      },
      isAprove: {
        value: '',
        fieldName: 'is_approve',
        require: false,
        is_file: false,
      },
      isRental: {
        value: '',
        fieldName: ' rental_agreement',
        require: false,
        is_file: false,
      },
      dateDocLeasing: {
        fieldName: 'additional',
        type_file: 11,
        is_file: true,
      },
      vehicle_type_id: {
        value: '',
        require: false,
        fieldName: 'vehicle_type_id',
        is_file: false,
      },
    }

    if (autos) {
      for (let key in autos) {
        for (let key1 in this.data) {
          if (this.data[key1].fieldName === key) {
            this.set(key1, autos[key])
            break
          }
        }
      }
    }
  }
}

export default Auto
